import { mapServerToProductBase } from "./map-server-to-product-base.js";
import { mapServerToSolutionsVariant } from "../../../../variant-mappers/mappers/server-to-client/variant-mappers/map-server-to-solutions-variant.js";
const mapServerToSolutionsProduct = (serverProduct, slug, locale, facetConfigList, flatFacetConfigList, priceSegmentChannelKey) => {
  if (serverProduct?.__typename !== "SolutionProduct") {
    return {
      failure: "incorrect-typename",
      message: `Expected SolutionProduct for slug "${slug}", but got ${serverProduct?.__typename}`
    };
  }
  const variants = mapServerToSolutionsVariant(serverProduct, slug, locale, priceSegmentChannelKey);
  if (!variants || variants.length === 0) {
    return {
      failure: "no-variants",
      message: `Cannot return Solutions product with slug: "${slug}" because it has no variants`
    };
  }
  return {
    ...mapServerToProductBase(serverProduct, variants, facetConfigList, flatFacetConfigList),
    productType: "Solutions",
    variants,
    isExclusiveBrand: serverProduct.productTypeDetails?.exclusiveBrand ?? void 0
  };
};
export {
  mapServerToSolutionsProduct
};
//# sourceMappingURL=map-server-to-solutions-product.js.map
